export default __webpack_public_path__ + "static/media/969.1a0e8f81.png";